// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__YOpH0","header":"Modal_header__JpbAd","groupLeft":"Modal_groupLeft__9pgSu","icon":"Modal_icon__T1PRn"};